export const logEvent = (event_name, event_props = {}, callback = false) => {
  // analytics.track(event_name, event_props);
  if (isTest()) console.log('Analytics Event:', event_name, event_props);
  if (callback) callback();
};

export const logPage = () => {
  // analytics.page();
  if (isTest()) console.log('Analytics Page:', window.location.pathname);
};

export const logIdentify = (id, props = {}) => {
  // note: this also happens on initial load in the react layout
  // analytics.identify(id, props);
  if (isTest()) console.log('Analytics Identify:', id, props);
};

export const isTest = () => {
  var host = window.location.hostname;
  return (
    host == 'localhost' ||
    host == 'dev.harborplan.com' ||
    host == 'staging.harborplan.com'
  );
};
